<template>
<div class="page page_iteminfo page_co">
	<!--  代理商 -->
	<van-list v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" @load="getData" >
		<div class="jiangren">
			<div class="con" v-for="(agent,index) in agentList" :key="index">
				<div class="con_info">
					<div class="thumb" v-if="agent.firstagent.userdata">
						<img :src="agent.firstagent.userdata.thumb ? ($publicData.withHttpStart(agent.firstagent.userdata.thumb) ? agent.firstagent.userdata.thumb :  imageUrl+agent.firstagent.userdata.thumb) : $publicData.defaultTouxiang" alt="" class="">
					</div>
					<div class="name" v-if="agent.firstagent.userdata">{{ agent.firstagent.userdata.nickname }}</div>
				</div>
			</div>
		</div>
	</van-list>	
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
			token: '',
			agentList: [], // 一级分销商
			pages: {
				page: 1,
				size: 10
			},
			loading: true,
			finished: false
        };
    },
    created: function () {
		
    },
    mounted: function () {
		console.log('mounted')
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '一级分销商',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.getData()
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
			// 获取列表
			this.getData()
        }

    },
    methods: {
        // 获取列表
        getData() {
            if (this.token == null || this.token == undefined || this.token == '') {
                return
            }
            var params = {
				token: this.token,
				page: this.pages.page,
				size: this.pages.size
			}
			this.$api.park.firstagentlist(params).then(res=>{
				if(res.code == 200){
					var list = res.result
					if(list.length != 0){
						this.agentList = this.agentList.concat(list)
						this.pages.page ++
						this.loading = false
					}else{
						this.finished = true
					}
				}else{
					this.finished = true
				}
			})
        },   
	},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
